// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendors-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 0;
}

.add-vendor-btn {
  padding: 12px 24px;
  background-color: #7FBD2C;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.add-vendor-btn:hover {
  background-color: rgb(157, 161, 159);
  transform: translateY(-1px);
}

.add-vendor-btn:active {
  transform: translateY(0);
}

.vendor-search-container {
  display: flex;
  align-items: center;
  width: 250px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease;
}

.search-container:focus-within {
  border-color: #00468C;
}

.search-input {
  flex: 1 1;
  border: none;
  font-size: 14px;
  outline: none;
  background-color: transparent;
}

.search-icon {
  color: #666;
  font-size: 14px;
}

.vendor-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.vendor-popup-form {
  position: relative;
  background-color: #F5F5F5;
  color: #000;
  padding: 30px;
  border-radius: 8px;
  width: 70%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.vendor-popup-box {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  width: 600px;
  max-width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
}

.vendor-popup-form fieldset {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.vendor-popup-form legend {
  font-weight: 600;
  color: #00468C;
  font-size: 18px;
  padding: 0 10px;
}

.vendor-popup-form input,
.vendor-popup-form select {
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.vendor-popup-form input:focus,
.vendor-popup-form select:focus {
  border-color: #00468C;
  outline: none;
}

.vendor-popup-form input#registered_address,
.vendor-popup-form input#branch_address {
  padding: 20px 10px;
  line-height: 1.5;
  min-height: 60px;
}

.vendor-popup-form label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.vendor-form-title {
  background-color: #00468C;
  color: white;
  padding: 15px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: -20px -30px 30px -30px;
  font-size: 22px;
  font-weight: 600;
}

.vendor-popup-title {
  background-color: #00468C;
  color: white;
  padding: 15px;
  margin: -20px -20px 20px -20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.vendor-popup-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #ffffff;
  color: #00468C;
  border: 2px solid #00468C;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.vendor-popup-close-btn:hover {
  background-color: #00468C;
  color: white;
  transform: scale(1.1);
}

.vendor-form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}

.vendor-close-btn,
.vendor-submit-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.vendor-close-btn {
  background-color: #e0e0e0;
  color: #333;
}

.vendor-close-btn:hover {
  background-color: #d0d0d0;
}

.vendor-submit-btn {
  background-color: #00468C;
  color: white;
}

.vendor-submit-btn:hover {
  background-color: #003a6e;
}

.table-scroll-wrapper {
  width: 100%;
  max-width: 1200px;
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.vendor-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: auto;
}

.vendor-table th,
.vendor-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
}

.vendor-table th {
  background-color: #00468C;
  color: white;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.vendor-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.vendor-table tr:hover {
  background-color: #f1f1f1;
}

.vendor-table th:nth-child(1),
.vendor-table td:nth-child(1) { /* Vendor ID */
  width: 60px;
}

.vendor-table th:nth-child(2),
.vendor-table td:nth-child(2) { /* Company Name */
  width: 150px;
}

.vendor-table th:nth-child(3),
.vendor-table td:nth-child(3) { /* Company Details */
  width: 100px;
}

.vendor-table th:nth-child(4),
.vendor-table td:nth-child(4) { /* Contact Details */
  width: 100px;
}

.vendor-table th:nth-child(5),
.vendor-table td:nth-child(5) { /* Bank Details */
  width: 100px;
}

.vendor-table th:nth-child(6),
.vendor-table td:nth-child(6) { /* Business Information */
  width: 120px;
}

.vendor-table th:nth-child(7),
.vendor-table td:nth-child(7) { /* Documents */
  min-width: 120px !important;
  text-align: center;
  white-space: nowrap;
}

.view-documents-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 6px;
  margin: 0;
  display: inline-block;
  color: black;
}

.view-documents-btn:hover {
  color: black;
}

.download-all-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 6px;
  margin: 0;
  display: inline-block;
  color: white;
  transition: color 0.2s ease;
}

.download-all-btn:hover {
  color: #28a745;
}

.document-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.documents-popup {
  max-width: 400px;
  padding: 20px;
  background-color: #F5F5F5;
  border-radius: 8px;
}

.documents-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.documents-list li {
  margin-bottom: 10px;
}

.file-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}

.file-link:hover {
  color: #0056b3;
}

.file-link.disabled {
  color: #999;
  cursor: not-allowed;
  text-decoration: none;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-name {
  flex: 1 1;
  color: #333;
}






.feildsetbankdetails,
.companydetailsfeildset,
.feildsetbusinessinformation {
  margin-top: 20px;
  margin-bottom: 20px;
}

.contact-fieldset.spaced {
  margin-top: 20px;
  margin-bottom: 20px;
}

.contact-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.contact-row.four-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.four-columns .contact-field {
  flex: 1 1 25%;
  min-width: 0;
}

.contact-row.three-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.three-columns .contact-field {
  flex: 1 1 33.33%;
  min-width: 0;
}

.contact-row.two-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.two-columns .contact-field {
  flex: 1 1 50%;
  min-width: 0;
}

.contact-row.full-width,
.contact-row.one-column {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.full-width .contact-field,
.contact-row.one-column .contact-field {
  flex: 1 1 100%;
}

.contact-field {
  display: flex;
  flex-direction: column;
  min-width: 150px;
}

.error-message {
  color: #d32f2f;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
}

.vendor-details-container {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.details-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.details-table th,
.details-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.details-table tr:last-child td {
  border-bottom: none;
}

.details-table tr:hover {
  background-color: #f5f9ff;
}

.details-table .details-label {
  width: 40%;
  font-weight: 600;
  color: #333;
  background-color: #f9f9f9;
}

.details-table .details-value {
  width: 60%;
  color: #555;
}

.contact-table-wrapper {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.contact-table-header {
  font-size: 16px;
  font-weight: 600;
  color: #00468C;
  margin-bottom: 12px;
  padding: 5px 0;
  border-bottom: 3px solid #00468C;
  text-align: left;
}

.contact-table {
  border: 4px solid #333;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
}

.contact-table th,
.contact-table td {
  border: 3px solid #333;
  padding: 14px 18px;
  text-align: left;
}

.contact-table .details-label {
  background-color: #e6f0fa;
  font-weight: 600;
  color: #333;
}

.contact-table .details-value {
  background-color: #ffffff;
  color: #444;
}

.contact-table tr:last-child td {
  border-bottom: 3px solid #333;
}

.contact-table tr:hover {
  background-color: #f0f7ff;
}

.contact-table tr td:first-child {
  border-left: none;
}

.contact-table tr td:last-child {
  border-right: none;
}

.contact-table tr:first-child td {
  border-top: none;
}

.contact-table tr:last-child td {
  border-bottom: none;
}

.vendor-details-container p {
  margin: 8px 0;
  font-size: 14px;
}

.view-details-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.view-details-btn i {
  font-size: 14px;
  color: #16181a;
}

.view-details-btn:hover i {
  color: #0056b3;
}

.vendor-popup-form.small-popup {
  width: 700px;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
}

.vendor-popup-form.small-popup .vendor-form-title {
  font-size: 18px;
  margin-bottom: 15px;
}

.vendor-popup-form.small-popup .vendor-popup-close-btn {
  top: 10px;
  right: 10px;
  font-size: 18px;
}

.details-row {
  display: flex;
  margin-bottom: 10px;
}

.details-label {
  flex: 1 1 40%;
  font-weight: bold;
  color: #333;
}

.details-value {
  flex: 1 1 60%;
  color: #333;
}

.contact-field label {
  font-weight: bold;
  margin-bottom: 5px;
}
.vendors-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

/* .header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
} */

.add-vendor-btn {
  padding: 12px 24px;
  background-color: #7FBD2C;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s ease, transform 0.1s ease;
}



.add-vendor-btn:active {
  transform: translateY(0);
}

/* .search-container {
  display: flex;
  align-items: center;
  width: 250px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease;
} */

/* .search-container:focus-within {
  border-color: #00468C;
} */

.search-input {
  flex: 1 1;
  border: none;
  font-size: 14px;
  outline: none;
  background-color: transparent;
}

.search-icon {
  color: #666;
  font-size: 14px;
}

.vendor-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.vendor-popup-form {
  position: relative;
  background-color: #F5F5F5;
  color: #000;
  padding: 30px;
  border-radius: 8px;
  width: 70%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.vendor-popup-box {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  width: 600px;
  max-width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
}

.vendor-popup-form fieldset {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.vendor-popup-form legend {
  font-weight: 600;
  color: #00468C;
  font-size: 18px;
  padding: 0 10px;
}

.vendor-popup-form input,
.vendor-popup-form select {
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.vendor-popup-form input:focus,
.vendor-popup-form select:focus {
  border-color: #00468C;
  outline: none;
}

.vendor-popup-form input#registered_address,
.vendor-popup-form input#branch_address {
  padding: 20px 10px;
  line-height: 1.5;
  min-height: 60px;
}

.vendor-popup-form label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.vendor-form-title {
  background-color: #00468C;
  color: white;
  padding: 15px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: -20px -30px 30px -30px;
  font-size: 22px;
  font-weight: 600;
}

.vendor-popup-title {
  background-color: #00468C;
  color: white;
  padding: 15px;
  margin: -20px -20px 20px -20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.vendor-popup-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #ffffff;
  color: #00468C;
  border: 2px solid #00468C;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.vendor-popup-close-btn:hover {
  background-color: #00468C;
  color: white;
  transform: scale(1.1);
}

.vendor-form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}

.vendor-close-btn,
.vendor-submit-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.vendor-close-btn {
  background-color: #e0e0e0;
  color: #333;
}

.vendor-close-btn:hover {
  background-color: #d0d0d0;
}

.vendor-submit-btn {
  background-color: #00468C;
  color: white;
}

.vendor-submit-btn:hover {
  background-color: #003a6e;
}

.table-scroll-wrapper {
  width: 100%;
  max-width: 1200px;
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.vendor-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: auto;
}

.vendor-table th,
.vendor-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
}


.vendor-table th {
  background-color: white;
  color: black;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.vendor-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.vendor-table tr:hover {
  background-color: #f1f1f1;
}

.vendor-table th:nth-child(1),
.vendor-table td:nth-child(1) { /* Vendor ID */
  width: 60px;
}

.vendor-table th:nth-child(2),
.vendor-table td:nth-child(2) { /* Company Name */
  width: 150px;
}

.vendor-table th:nth-child(3),
.vendor-table td:nth-child(3) { /* Company Details */
  width: 100px;
}

.vendor-table th:nth-child(4),
.vendor-table td:nth-child(4) { /* Contact Details */
  width: 100px;
}

.vendor-table th:nth-child(5),
.vendor-table td:nth-child(5) { /* Bank Details */
  width: 100px;
}

.vendor-table th:nth-child(6),
.vendor-table td:nth-child(6) { /* Business Information */
  width: 120px;
}

.vendor-table th:nth-child(7),
.vendor-table td:nth-child(7) { /* Documents */
  min-width: 120px !important;
  text-align: center;
  white-space: nowrap;
}

.view-documents-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 6px;
  margin: 0;
  display: inline-block;
  color: black;
}

.view-documents-btn:hover {
  color: black;
}

.download-all-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 6px;
  margin: 0;
  display: inline-block;
  color: white;
  transition: color 0.2s ease;
}

.download-all-btn:hover {
  color: #28a745;
}

.document-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.documents-popup {
  max-width: 400px;
  padding: 20px;
  background-color: #F5F5F5;
  border-radius: 8px;
}

.documents-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.documents-list li {
  margin-bottom: 10px;
}

.file-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}

.file-link:hover {
  color: #0056b3;
}

.file-link.disabled {
  color: #999;
  cursor: not-allowed;
  text-decoration: none;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-name {
  flex: 1 1;
  color: #333;
}


.feildsetbankdetails,
.companydetailsfeildset,
.feildsetbusinessinformation {
  margin-top: 20px;
  margin-bottom: 20px;
}

.contact-fieldset.spaced {
  margin-top: 20px;
  margin-bottom: 20px;
}

.contact-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.contact-row.four-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.four-columns .contact-field {
  flex: 1 1 25%;
  min-width: 0;
}

.contact-row.three-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.three-columns .contact-field {
  flex: 1 1 33.33%;
  min-width: 0;
}

.contact-row.two-columns {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.two-columns .contact-field {
  flex: 1 1 50%;
  min-width: 0;
}

.contact-row.full-width,
.contact-row.one-column {
  display: flex;
  flex-wrap: nowrap;
}

.contact-row.full-width .contact-field,
.contact-row.one-column .contact-field {
  flex: 1 1 100%;
}

.contact-field {
  display: flex;
  flex-direction: column;
  min-width: 150px;
}

.error-message {
  color: #d32f2f;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
}

.vendor-details-container {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.details-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.details-table th,
.details-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.details-table tr:last-child td {
  border-bottom: none;
}

.details-table tr:hover {
  background-color: #f5f9ff;
}

.details-table .details-label {
  width: 40%;
  font-weight: 600;
  color: #333;
  background-color: #f9f9f9;
}

.details-table .details-value {
  width: 60%;
  color: #555;
}

.contact-box-wrapper {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.contact-box-header {
  font-size: 16px;
  font-weight: 600;
  color: #00468C;
  margin-bottom: 12px;
  padding: 5px 0;
  border-bottom: 3px solid #00468C;
  text-align: left;
}

.contact-box {
  background-color: #ffffff;
  border: 2px solid #333;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.1s ease;
}

.contact-box:hover {
  transform: translateY(-2px);
}

.contact-box-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
}

.contact-box-row:last-child {
  border-bottom: none;
}

.contact-label {
  font-weight: 600;
  color: #333;
  flex: 1 1 40%;
}

.contact-value {
  color: #444;
  flex: 1 1 60%;
  text-align: left;
}

.vendor-details-container p {
  margin: 8px 0;
  font-size: 14px;
}

.view-details-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.view-details-btn i {
  font-size: 14px;
  color: #16181a;
}

.view-details-btn:hover i {
  color: #0056b3;
}

.vendor-popup-form.small-popup {
  width: 700px;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
}

.vendor-popup-form.small-popup .vendor-form-title {
  font-size: 18px;
  margin-bottom: 15px;
}

.vendor-popup-form.small-popup .vendor-popup-close-btn {
  top: 10px;
  right: 10px;
  font-size: 18px;
}

.details-row {
  display: flex;
  margin-bottom: 10px;
}

.details-label {
  flex: 1 1 40%;
  font-weight: bold;
  color: #333;
}

.details-value {
  flex: 1 1 60%;
  color: #333;
}
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr;
  grid-template-rows: repeat(6, auto);
  border: 1px solid #e0e0e0;
}

.grid-label {
  border: 1px solid #e0e0e0;
  padding: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  grid-row: span 2;
}

.grid-field {
  border: 1px solid #e0e0e0;
  padding: 10px;
  font-size: 14px;
  background-color: #ffffff;
}
.vendor-view-doc-btn,
.vendor-download-doc-btn {
  display: flex;
  align-items: center;
  background-color: #7FBD2C;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color:white;
}

.vendor-view-doc-btn:hover,
.vendor-download-doc-btn:hover {
  background-color: #7FBD2C;
}


/* Responsive Design */
@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .add-vendor-btn {
    width: 100%;
    text-align: center;
  }

  .search-container {
    width: 100%;
  }

  .contact-row.four-columns,
  .contact-row.three-columns,
  .contact-row.two-columns {
    flex-wrap: wrap;
  }

  .contact-row.four-columns .contact-field,
  .contact-row.three-columns .contact-field,
  .contact-row.two-columns .contact-field {
    flex: 1 1 100%;
  }

  .vendor-popup-box {
    width: 90%;
    padding: 15px;
  }

  .details-table {
    font-size: 12px;
  }

  .details-table th,
  .details-table td {
    padding: 8px 12px;
  }

  .vendor-popup-title {
    font-size: 18px;
    padding: 12px;
  }

  .contact-box-header {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .contact-box-wrapper {
    padding: 10px;
    margin-bottom: 20px;
  }

  .contact-box {
    padding: 10px;
    border: 1px solid #333;
  }

  .contact-box-row {
    padding: 8px 0;
  }

  .contact-label,
  .contact-value {
    font-size: 12px;
  }
}
.contact-field span {
  font-size: 14px;
  color: red;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .add-vendor-btn {
    width: 100%;
    text-align: center;
  }

  .search-container {
    width: 100%;
  }

  .contact-row.four-columns,
  .contact-row.three-columns,
  .contact-row.two-columns {
    flex-wrap: wrap;
  }

  .contact-row.four-columns .contact-field,
  .contact-row.three-columns .contact-field,
  .contact-row.two-columns .contact-field {
    flex: 1 1 100%;
  }

  .vendor-popup-box {
    width: 90%;
    padding: 15px;
  }

  .details-table {
    font-size: 12px;
  }

  .details-table th,
  .details-table td {
    padding: 8px 12px;
  }

  .contact-table th,
  .contact-table td {
    padding: 10px 12px;
    border: 2px solid #333;
  }

  .contact-table {
    border: 3px solid #333;
  }

  .contact-table tr:last-child td {
    border-bottom: 2px solid #333;
  }

  .vendor-popup-title {
    font-size: 18px;
    padding: 12px;
  }

  .contact-table-header {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .contact-table-wrapper {
    padding: 10px;
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/vendors/vendors.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;gCACgC,cAAc;EAC5C,WAAW;AACb;;AAEA;gCACgC,iBAAiB;EAC/C,YAAY;AACd;;AAEA;gCACgC,oBAAoB;EAClD,YAAY;AACd;;AAEA;gCACgC,oBAAoB;EAClD,YAAY;AACd;;AAEA;gCACgC,iBAAiB;EAC/C,YAAY;AACd;;AAEA;gCACgC,yBAAyB;EACvD,YAAY;AACd;;AAEA;gCACgC,cAAc;EAC5C,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;;;;;;AAOA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2DAA2D;AAC7D;;;;AAIA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;GAUG;;AAEH;;GAEG;;AAEH;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;gCACgC,cAAc;EAC5C,WAAW;AACb;;AAEA;gCACgC,iBAAiB;EAC/C,YAAY;AACd;;AAEA;gCACgC,oBAAoB;EAClD,YAAY;AACd;;AAEA;gCACgC,oBAAoB;EAClD,YAAY;AACd;;AAEA;gCACgC,iBAAiB;EAC/C,YAAY;AACd;;AAEA;gCACgC,yBAAyB;EACvD,YAAY;AACd;;AAEA;gCACgC,cAAc;EAC5C,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;;AAGA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;;AAGA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".vendors-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  max-width: 1200px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 10px 0;\n}\n\n.add-vendor-btn {\n  padding: 12px 24px;\n  background-color: #7FBD2C;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.add-vendor-btn:hover {\n  background-color: rgb(157, 161, 159);\n  transform: translateY(-1px);\n}\n\n.add-vendor-btn:active {\n  transform: translateY(0);\n}\n\n.vendor-search-container {\n  display: flex;\n  align-items: center;\n  width: 250px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: border-color 0.2s ease;\n}\n\n.search-container:focus-within {\n  border-color: #00468C;\n}\n\n.search-input {\n  flex: 1;\n  border: none;\n  font-size: 14px;\n  outline: none;\n  background-color: transparent;\n}\n\n.search-icon {\n  color: #666;\n  font-size: 14px;\n}\n\n.vendor-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.vendor-popup-form {\n  position: relative;\n  background-color: #F5F5F5;\n  color: #000;\n  padding: 30px;\n  border-radius: 8px;\n  width: 70%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.vendor-popup-box {\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 600px;\n  max-width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n}\n\n.vendor-popup-form fieldset {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.vendor-popup-form legend {\n  font-weight: 600;\n  color: #00468C;\n  font-size: 18px;\n  padding: 0 10px;\n}\n\n.vendor-popup-form input,\n.vendor-popup-form select {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n}\n\n.vendor-popup-form input:focus,\n.vendor-popup-form select:focus {\n  border-color: #00468C;\n  outline: none;\n}\n\n.vendor-popup-form input#registered_address,\n.vendor-popup-form input#branch_address {\n  padding: 20px 10px;\n  line-height: 1.5;\n  min-height: 60px;\n}\n\n.vendor-popup-form label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n.vendor-form-title {\n  background-color: #00468C;\n  color: white;\n  padding: 15px 20px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin: -20px -30px 30px -30px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.vendor-popup-title {\n  background-color: #00468C;\n  color: white;\n  padding: 15px;\n  margin: -20px -20px 20px -20px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.vendor-popup-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background-color: #ffffff;\n  color: #00468C;\n  border: 2px solid #00468C;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;\n}\n\n.vendor-popup-close-btn:hover {\n  background-color: #00468C;\n  color: white;\n  transform: scale(1.1);\n}\n\n.vendor-form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.vendor-close-btn,\n.vendor-submit-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.vendor-close-btn {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.vendor-close-btn:hover {\n  background-color: #d0d0d0;\n}\n\n.vendor-submit-btn {\n  background-color: #00468C;\n  color: white;\n}\n\n.vendor-submit-btn:hover {\n  background-color: #003a6e;\n}\n\n.table-scroll-wrapper {\n  width: 100%;\n  max-width: 1200px;\n  max-height: 400px;\n  overflow-x: auto;\n  overflow-y: auto;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.vendor-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: auto;\n}\n\n.vendor-table th,\n.vendor-table td {\n  padding: 12px;\n  border: 1px solid #ddd;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.vendor-table th {\n  background-color: #00468C;\n  color: white;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.vendor-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.vendor-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.vendor-table th:nth-child(1),\n.vendor-table td:nth-child(1) { /* Vendor ID */\n  width: 60px;\n}\n\n.vendor-table th:nth-child(2),\n.vendor-table td:nth-child(2) { /* Company Name */\n  width: 150px;\n}\n\n.vendor-table th:nth-child(3),\n.vendor-table td:nth-child(3) { /* Company Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(4),\n.vendor-table td:nth-child(4) { /* Contact Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(5),\n.vendor-table td:nth-child(5) { /* Bank Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(6),\n.vendor-table td:nth-child(6) { /* Business Information */\n  width: 120px;\n}\n\n.vendor-table th:nth-child(7),\n.vendor-table td:nth-child(7) { /* Documents */\n  min-width: 120px !important;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.view-documents-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 6px;\n  margin: 0;\n  display: inline-block;\n  color: black;\n}\n\n.view-documents-btn:hover {\n  color: black;\n}\n\n.download-all-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 6px;\n  margin: 0;\n  display: inline-block;\n  color: white;\n  transition: color 0.2s ease;\n}\n\n.download-all-btn:hover {\n  color: #28a745;\n}\n\n.document-actions {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: nowrap !important;\n  white-space: nowrap;\n}\n\n.documents-popup {\n  max-width: 400px;\n  padding: 20px;\n  background-color: #F5F5F5;\n  border-radius: 8px;\n}\n\n.documents-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px 0;\n}\n\n.documents-list li {\n  margin-bottom: 10px;\n}\n\n.file-link {\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.file-link:hover {\n  color: #0056b3;\n}\n\n.file-link.disabled {\n  color: #999;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.file-name {\n  flex: 1;\n  color: #333;\n}\n\n\n\n\n\n\n.feildsetbankdetails,\n.companydetailsfeildset,\n.feildsetbusinessinformation {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.contact-fieldset.spaced {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.contact-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: nowrap;\n}\n\n.contact-row.four-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.four-columns .contact-field {\n  flex: 1 1 25%;\n  min-width: 0;\n}\n\n.contact-row.three-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.three-columns .contact-field {\n  flex: 1 1 33.33%;\n  min-width: 0;\n}\n\n.contact-row.two-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.two-columns .contact-field {\n  flex: 1 1 50%;\n  min-width: 0;\n}\n\n.contact-row.full-width,\n.contact-row.one-column {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.full-width .contact-field,\n.contact-row.one-column .contact-field {\n  flex: 1 1 100%;\n}\n\n.contact-field {\n  display: flex;\n  flex-direction: column;\n  min-width: 150px;\n}\n\n.error-message {\n  color: #d32f2f;\n  font-size: 12px;\n  margin-top: -10px;\n  margin-bottom: 10px;\n}\n\n.vendor-details-container {\n  padding: 20px;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.details-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.details-table th,\n.details-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.details-table tr:last-child td {\n  border-bottom: none;\n}\n\n.details-table tr:hover {\n  background-color: #f5f9ff;\n}\n\n.details-table .details-label {\n  width: 40%;\n  font-weight: 600;\n  color: #333;\n  background-color: #f9f9f9;\n}\n\n.details-table .details-value {\n  width: 60%;\n  color: #555;\n}\n\n.contact-table-wrapper {\n  margin-bottom: 30px;\n  padding: 15px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.contact-table-header {\n  font-size: 16px;\n  font-weight: 600;\n  color: #00468C;\n  margin-bottom: 12px;\n  padding: 5px 0;\n  border-bottom: 3px solid #00468C;\n  text-align: left;\n}\n\n.contact-table {\n  border: 4px solid #333;\n  border-radius: 6px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  background-color: #ffffff;\n}\n\n.contact-table th,\n.contact-table td {\n  border: 3px solid #333;\n  padding: 14px 18px;\n  text-align: left;\n}\n\n.contact-table .details-label {\n  background-color: #e6f0fa;\n  font-weight: 600;\n  color: #333;\n}\n\n.contact-table .details-value {\n  background-color: #ffffff;\n  color: #444;\n}\n\n.contact-table tr:last-child td {\n  border-bottom: 3px solid #333;\n}\n\n.contact-table tr:hover {\n  background-color: #f0f7ff;\n}\n\n.contact-table tr td:first-child {\n  border-left: none;\n}\n\n.contact-table tr td:last-child {\n  border-right: none;\n}\n\n.contact-table tr:first-child td {\n  border-top: none;\n}\n\n.contact-table tr:last-child td {\n  border-bottom: none;\n}\n\n.vendor-details-container p {\n  margin: 8px 0;\n  font-size: 14px;\n}\n\n.view-details-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.view-details-btn i {\n  font-size: 14px;\n  color: #16181a;\n}\n\n.view-details-btn:hover i {\n  color: #0056b3;\n}\n\n.vendor-popup-form.small-popup {\n  width: 700px;\n  max-height: 80vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 15px;\n}\n\n.vendor-popup-form.small-popup .vendor-form-title {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.vendor-popup-form.small-popup .vendor-popup-close-btn {\n  top: 10px;\n  right: 10px;\n  font-size: 18px;\n}\n\n.details-row {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.details-label {\n  flex: 1 1 40%;\n  font-weight: bold;\n  color: #333;\n}\n\n.details-value {\n  flex: 1 1 60%;\n  color: #333;\n}\n\n.contact-field label {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n.vendors-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* .header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 10px 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n} */\n\n.add-vendor-btn {\n  padding: 12px 24px;\n  background-color: #7FBD2C;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n\n\n.add-vendor-btn:active {\n  transform: translateY(0);\n}\n\n/* .search-container {\n  display: flex;\n  align-items: center;\n  width: 250px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: border-color 0.2s ease;\n} */\n\n/* .search-container:focus-within {\n  border-color: #00468C;\n} */\n\n.search-input {\n  flex: 1;\n  border: none;\n  font-size: 14px;\n  outline: none;\n  background-color: transparent;\n}\n\n.search-icon {\n  color: #666;\n  font-size: 14px;\n}\n\n.vendor-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.vendor-popup-form {\n  position: relative;\n  background-color: #F5F5F5;\n  color: #000;\n  padding: 30px;\n  border-radius: 8px;\n  width: 70%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.vendor-popup-box {\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 600px;\n  max-width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n}\n\n.vendor-popup-form fieldset {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.vendor-popup-form legend {\n  font-weight: 600;\n  color: #00468C;\n  font-size: 18px;\n  padding: 0 10px;\n}\n\n.vendor-popup-form input,\n.vendor-popup-form select {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n}\n\n.vendor-popup-form input:focus,\n.vendor-popup-form select:focus {\n  border-color: #00468C;\n  outline: none;\n}\n\n.vendor-popup-form input#registered_address,\n.vendor-popup-form input#branch_address {\n  padding: 20px 10px;\n  line-height: 1.5;\n  min-height: 60px;\n}\n\n.vendor-popup-form label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n.vendor-form-title {\n  background-color: #00468C;\n  color: white;\n  padding: 15px 20px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin: -20px -30px 30px -30px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.vendor-popup-title {\n  background-color: #00468C;\n  color: white;\n  padding: 15px;\n  margin: -20px -20px 20px -20px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.vendor-popup-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background-color: #ffffff;\n  color: #00468C;\n  border: 2px solid #00468C;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;\n}\n\n.vendor-popup-close-btn:hover {\n  background-color: #00468C;\n  color: white;\n  transform: scale(1.1);\n}\n\n.vendor-form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.vendor-close-btn,\n.vendor-submit-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.vendor-close-btn {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.vendor-close-btn:hover {\n  background-color: #d0d0d0;\n}\n\n.vendor-submit-btn {\n  background-color: #00468C;\n  color: white;\n}\n\n.vendor-submit-btn:hover {\n  background-color: #003a6e;\n}\n\n.table-scroll-wrapper {\n  width: 100%;\n  max-width: 1200px;\n  max-height: 400px;\n  overflow-x: auto;\n  overflow-y: auto;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.vendor-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: auto;\n}\n\n.vendor-table th,\n.vendor-table td {\n  padding: 12px;\n  border: 1px solid #ddd;\n  text-align: left;\n  white-space: nowrap;\n}\n\n\n.vendor-table th {\n  background-color: white;\n  color: black;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.vendor-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.vendor-table tr:hover {\n  background-color: #f1f1f1;\n}\n\n.vendor-table th:nth-child(1),\n.vendor-table td:nth-child(1) { /* Vendor ID */\n  width: 60px;\n}\n\n.vendor-table th:nth-child(2),\n.vendor-table td:nth-child(2) { /* Company Name */\n  width: 150px;\n}\n\n.vendor-table th:nth-child(3),\n.vendor-table td:nth-child(3) { /* Company Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(4),\n.vendor-table td:nth-child(4) { /* Contact Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(5),\n.vendor-table td:nth-child(5) { /* Bank Details */\n  width: 100px;\n}\n\n.vendor-table th:nth-child(6),\n.vendor-table td:nth-child(6) { /* Business Information */\n  width: 120px;\n}\n\n.vendor-table th:nth-child(7),\n.vendor-table td:nth-child(7) { /* Documents */\n  min-width: 120px !important;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.view-documents-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 6px;\n  margin: 0;\n  display: inline-block;\n  color: black;\n}\n\n.view-documents-btn:hover {\n  color: black;\n}\n\n.download-all-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 6px;\n  margin: 0;\n  display: inline-block;\n  color: white;\n  transition: color 0.2s ease;\n}\n\n.download-all-btn:hover {\n  color: #28a745;\n}\n\n.document-actions {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: nowrap !important;\n  white-space: nowrap;\n}\n\n.documents-popup {\n  max-width: 400px;\n  padding: 20px;\n  background-color: #F5F5F5;\n  border-radius: 8px;\n}\n\n.documents-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px 0;\n}\n\n.documents-list li {\n  margin-bottom: 10px;\n}\n\n.file-link {\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.file-link:hover {\n  color: #0056b3;\n}\n\n.file-link.disabled {\n  color: #999;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.file-name {\n  flex: 1;\n  color: #333;\n}\n\n\n.feildsetbankdetails,\n.companydetailsfeildset,\n.feildsetbusinessinformation {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.contact-fieldset.spaced {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.contact-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: nowrap;\n}\n\n.contact-row.four-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.four-columns .contact-field {\n  flex: 1 1 25%;\n  min-width: 0;\n}\n\n.contact-row.three-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.three-columns .contact-field {\n  flex: 1 1 33.33%;\n  min-width: 0;\n}\n\n.contact-row.two-columns {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.two-columns .contact-field {\n  flex: 1 1 50%;\n  min-width: 0;\n}\n\n.contact-row.full-width,\n.contact-row.one-column {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.contact-row.full-width .contact-field,\n.contact-row.one-column .contact-field {\n  flex: 1 1 100%;\n}\n\n.contact-field {\n  display: flex;\n  flex-direction: column;\n  min-width: 150px;\n}\n\n.error-message {\n  color: #d32f2f;\n  font-size: 12px;\n  margin-top: -10px;\n  margin-bottom: 10px;\n}\n\n.vendor-details-container {\n  padding: 20px;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.details-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.details-table th,\n.details-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.details-table tr:last-child td {\n  border-bottom: none;\n}\n\n.details-table tr:hover {\n  background-color: #f5f9ff;\n}\n\n.details-table .details-label {\n  width: 40%;\n  font-weight: 600;\n  color: #333;\n  background-color: #f9f9f9;\n}\n\n.details-table .details-value {\n  width: 60%;\n  color: #555;\n}\n\n.contact-box-wrapper {\n  margin-bottom: 30px;\n  padding: 15px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.contact-box-header {\n  font-size: 16px;\n  font-weight: 600;\n  color: #00468C;\n  margin-bottom: 12px;\n  padding: 5px 0;\n  border-bottom: 3px solid #00468C;\n  text-align: left;\n}\n\n.contact-box {\n  background-color: #ffffff;\n  border: 2px solid #333;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  transition: transform 0.1s ease;\n}\n\n.contact-box:hover {\n  transform: translateY(-2px);\n}\n\n.contact-box-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.contact-box-row:last-child {\n  border-bottom: none;\n}\n\n.contact-label {\n  font-weight: 600;\n  color: #333;\n  flex: 1 1 40%;\n}\n\n.contact-value {\n  color: #444;\n  flex: 1 1 60%;\n  text-align: left;\n}\n\n.vendor-details-container p {\n  margin: 8px 0;\n  font-size: 14px;\n}\n\n.view-details-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.view-details-btn i {\n  font-size: 14px;\n  color: #16181a;\n}\n\n.view-details-btn:hover i {\n  color: #0056b3;\n}\n\n.vendor-popup-form.small-popup {\n  width: 700px;\n  max-height: 80vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 15px;\n}\n\n.vendor-popup-form.small-popup .vendor-form-title {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.vendor-popup-form.small-popup .vendor-popup-close-btn {\n  top: 10px;\n  right: 10px;\n  font-size: 18px;\n}\n\n.details-row {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.details-label {\n  flex: 1 1 40%;\n  font-weight: bold;\n  color: #333;\n}\n\n.details-value {\n  flex: 1 1 60%;\n  color: #333;\n}\n.contact-grid {\n  display: grid;\n  grid-template-columns: 1fr 2fr 2fr;\n  grid-template-rows: repeat(6, auto);\n  border: 1px solid #e0e0e0;\n}\n\n.grid-label {\n  border: 1px solid #e0e0e0;\n  padding: 10px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9f9f9;\n  grid-row: span 2;\n}\n\n.grid-field {\n  border: 1px solid #e0e0e0;\n  padding: 10px;\n  font-size: 14px;\n  background-color: #ffffff;\n}\n.vendor-view-doc-btn,\n.vendor-download-doc-btn {\n  display: flex;\n  align-items: center;\n  background-color: #7FBD2C;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color:white;\n}\n\n.vendor-view-doc-btn:hover,\n.vendor-download-doc-btn:hover {\n  background-color: #7FBD2C;\n}\n\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .header-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .add-vendor-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .search-container {\n    width: 100%;\n  }\n\n  .contact-row.four-columns,\n  .contact-row.three-columns,\n  .contact-row.two-columns {\n    flex-wrap: wrap;\n  }\n\n  .contact-row.four-columns .contact-field,\n  .contact-row.three-columns .contact-field,\n  .contact-row.two-columns .contact-field {\n    flex: 1 1 100%;\n  }\n\n  .vendor-popup-box {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .details-table {\n    font-size: 12px;\n  }\n\n  .details-table th,\n  .details-table td {\n    padding: 8px 12px;\n  }\n\n  .vendor-popup-title {\n    font-size: 18px;\n    padding: 12px;\n  }\n\n  .contact-box-header {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  .contact-box-wrapper {\n    padding: 10px;\n    margin-bottom: 20px;\n  }\n\n  .contact-box {\n    padding: 10px;\n    border: 1px solid #333;\n  }\n\n  .contact-box-row {\n    padding: 8px 0;\n  }\n\n  .contact-label,\n  .contact-value {\n    font-size: 12px;\n  }\n}\n.contact-field span {\n  font-size: 14px;\n  color: red;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .header-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .add-vendor-btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .search-container {\n    width: 100%;\n  }\n\n  .contact-row.four-columns,\n  .contact-row.three-columns,\n  .contact-row.two-columns {\n    flex-wrap: wrap;\n  }\n\n  .contact-row.four-columns .contact-field,\n  .contact-row.three-columns .contact-field,\n  .contact-row.two-columns .contact-field {\n    flex: 1 1 100%;\n  }\n\n  .vendor-popup-box {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .details-table {\n    font-size: 12px;\n  }\n\n  .details-table th,\n  .details-table td {\n    padding: 8px 12px;\n  }\n\n  .contact-table th,\n  .contact-table td {\n    padding: 10px 12px;\n    border: 2px solid #333;\n  }\n\n  .contact-table {\n    border: 3px solid #333;\n  }\n\n  .contact-table tr:last-child td {\n    border-bottom: 2px solid #333;\n  }\n\n  .vendor-popup-title {\n    font-size: 18px;\n    padding: 12px;\n  }\n\n  .contact-table-header {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  .contact-table-wrapper {\n    padding: 10px;\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
